<template>
  <div class="pg-page-querys">
    <div class="pg-page-querys__tag">
      <div
        class="pg-page-querys__tag-item"
        :class="{ 'pg-page-querys__tag-item--active': item.id === pageQuery?.id }"
        v-for="item in list"
        :key="item.id"
        @click="changeModel(item.id)"
      >
        <i v-if="item.icon" :class="item.icon"></i>
        <span>{{ item.name }}</span>
      </div>
    </div>
    <template v-if="!!pageQuery">
      <Transition name="el-fade-in-linear" mode="out-in">
        <KeepAlive :include="keepAliveInclude">
          <component
            :is="PgPageQuery"
            :key="pageQuery.id"
            v-bind="pageQuery.itemProps"
            :parametersStorageSuffix="pageQuery.id"
          ></component>
        </KeepAlive>
      </Transition>
    </template>
  </div>
</template>
<script setup>
import PgPageQuery from './page-query.vue'
import { onMounted, shallowRef, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router/composables'
import { localStorage } from 'pangu-core'

const props = defineProps({
  list: Array,
  // 默认渲染的下标
  defaultQuery: {
    type: Number,
    default: 0,
  },
})
const pageQuery = shallowRef(null)
const changeTag = (tagId) => {
  if (!tagId) {
    console.error('当前tag不存在')
    return
  }
  const tempQuery = props.list.find((im) => im.id === tagId) ?? {}
  const { id, name, icon, ...itemProps } = tempQuery
  pageQuery.value = id
    ? {
        id,
        name,
        icon,
        itemProps,
      }
    : null
  localStorage.set(
    `${route.name}_plus_page_querys_tag`,
    props.list.findIndex((im) => im.id === tagId)
  )
}
const route = useRoute()
onMounted(() => {
  if (props.list.length > 0) {
    const defaultIndex = localStorage.get(`${route.name}_plus_page_querys_tag`)
    const detailModel = route.query?.parameters?.detailModel
    const parameterIndex = detailModel ? props.list.findIndex((im) => im.id === detailModel) : -1
    const index = parameterIndex > -1 ? parameterIndex : defaultIndex ?? props.defaultQuery
    changeTag(props.list[index].id)
  }
})

const keepAliveInclude = shallowRef(['page-query'])
onBeforeUnmount(() => {
  keepAliveInclude.value = []
})

const emit = defineEmits(['changeModel'])
const changeModel = (id) => {
  changeTag(id)
  emit('changeModel', id)
}
</script>
<style lang="scss">
@import '../style/page-querys.scss';
</style>
